import styled from 'styled-components';

import { colors } from 'config/theme';

export const FieldGroupWrapper = styled.div`
  width: 300px;
  display: flex;
  flex-flow: column;
  & > div {
    margin-bottom: 20px;
  }
`;

export const FieldGroupBorder = styled.div`
  border-left: 1px solid ${colors.lightGray};
  border-bottom: 1px solid ${colors.lightGray};
  border-right: 1px solid ${colors.lightGray};
  width: 100%;
  display: flex;
  padding: 20px;
  flex-flow: column;
  align-items: center;
  padding-bottom: 20px;

  .cage_ncage_text {
    margin-bottom: unset;
    > div {
      padding-right: 0.11em;
    }
  }

  .cage_ncage_info {
    padding: 0.5em;
    font-size: 12px;

    .cage {
      margin-left: 0.78em;
    }

    div span {
      margin-left: 0.15em;
    }
  }
`;

export const ContentWrapper = styled.div`
  padding-top: unset;
  display: flex;
  flex-flow: column;
`;
